import React from "react";
import {
  Modal,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import Cross from "@assets/svg/CrossIcon";
import color from "@constants/color";
import { useSelector } from "react-redux";
import PayoutComponent from "./PayoutComponent";
import PickupComponent from "./PickupComponent";
import SkeletonLoaderList from "@components/SkeletonLoaderList";
import { ModalType } from "../utils";
import {
  AttendanceIncentiveModalBody,
  DeliveryIncentiveModalBody,
} from "../../../DeliveryPerformance/components/PlanModalComponents";

interface WalletModalProps {
  showModal: boolean;
  setShowModal: (visible: boolean) => void;
  modalType: string;
}

const WalletModal: React.FC<WalletModalProps> = ({
  showModal,
  setShowModal,
  modalType,
}) => {
  const { modalData, modalLoading } = useSelector(
    (state) => state.walletReducer,
  );

  const renderChildren = () => {
    switch (modalType) {
      case ModalType.PAYOUT_PLAN:
        return (
          <PayoutComponent title={modalData?.title} lines={modalData?.lines} />
        );
      case ModalType.REFUND_ITEMS:
        return (
          <PickupComponent title={modalData?.title} lines={modalData?.lines} />
        );
      case ModalType.DELIVERY_INCENTIVE:
        return (
          <DeliveryIncentiveModalBody
            title={modalData?.title}
            lines={modalData?.lines}
          />
        );
      case ModalType.ATTENDANCE_INCENTIVE:
        return (
          <AttendanceIncentiveModalBody
            title={modalData?.title}
            lines={modalData?.lines}
          />
        );
      default:
        return null;
    }
  };
  return (
    <Modal visible={showModal} animationType="slide" transparent>
      <TouchableWithoutFeedback
        onPress={() => {
          setShowModal(false);
        }}
      >
        <View style={styles.modalOverlay} />
      </TouchableWithoutFeedback>
      <View style={styles.modalContent}>
        <View style={styles.modalCross}>
          <TouchableWithoutFeedback onPress={() => setShowModal(false)}>
            <Cross width={16} height={16} />
          </TouchableWithoutFeedback>
        </View>
        <View style={styles.modalInnerContent}>
          {modalLoading ? (
            <SkeletonLoaderList isLoading={modalLoading} length={2} />
          ) : (
            renderChildren()
          )}
        </View>
      </View>
    </Modal>
  );
};

export default WalletModal;

const styles = StyleSheet.create({
  modalOverlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    flex: 1,
  },
  modalContent: {
    backgroundColor: color.white,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
    maxHeight: "70%",
  },
  modalCross: {
    position: "absolute",
    right: 10,
    top: -35,
    backgroundColor: "#fff",
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
  },
  modalInnerContent: {
    padding: 16,
  },
});
